import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-transmission" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Otra deducción"),
  /*#__PURE__*/_createElementVNode("th", null, "Pensión voluntaria"),
  /*#__PURE__*/_createElementVNode("th", null, "Retención fuente"),
  /*#__PURE__*/_createElementVNode("th", null, "AFC"),
  /*#__PURE__*/_createElementVNode("th", null, "Cooperativa")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }
const _hoisted_8 = { class: "tooltip-container" }
const _hoisted_9 = { class: "table-transmission" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Embargo fiscal"),
  /*#__PURE__*/_createElementVNode("th", null, "Plan complementario"),
  /*#__PURE__*/_createElementVNode("th", null, "Educación"),
  /*#__PURE__*/_createElementVNode("th", null, "Reintegro"),
  /*#__PURE__*/_createElementVNode("th", null, "Deuda")
], -1)
const _hoisted_11 = { class: "error-transmission" }
const _hoisted_12 = { class: "tooltip-container" }
const _hoisted_13 = { class: "tooltip-container" }
const _hoisted_14 = { class: "tooltip-container" }
const _hoisted_15 = { class: "tooltip-container" }
const _hoisted_16 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.OtherDeduction.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[0] || (_cache[0] = ($event: any) => ($setup.v$.OtherDeduction.$touch())),
              modelValue: $setup.OD.OtherDeductions[0],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.OD.OtherDeductions[0]) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.VoluntaryPension.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.VoluntaryPension.$touch())),
              modelValue: $setup.OD.GeneralDeductions.VoluntaryPension,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.OD.GeneralDeductions.VoluntaryPension) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.WithHoldingAtSource.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.WithHoldingAtSource.$touch())),
              modelValue: $setup.OD.GeneralDeductions.WithHoldingAtSource,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.OD.GeneralDeductions.WithHoldingAtSource) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.SavingsToPromoteConstruction.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[6] || (_cache[6] = ($event: any) => ($setup.v$.SavingsToPromoteConstruction.$touch())),
              modelValue: $setup.OD.GeneralDeductions.SavingsToPromoteConstruction,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.OD.GeneralDeductions.SavingsToPromoteConstruction) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Cooperative.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[8] || (_cache[8] = ($event: any) => ($setup.v$.Cooperative.$touch())),
              modelValue: $setup.OD.GeneralDeductions.Cooperative,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.OD.GeneralDeductions.Cooperative) = $event))
            }, null, 8, ["modelValue", "class"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.OtherDeduction.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.OtherDeduction.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.VoluntaryPension.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.VoluntaryPension.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.WithHoldingAtSource.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.WithHoldingAtSource.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SavingsToPromoteConstruction.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.SavingsToPromoteConstruction.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Cooperative.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Cooperative.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.TaxEmbargo.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[10] || (_cache[10] = ($event: any) => ($setup.v$.TaxEmbargo.$touch())),
              modelValue: $setup.OD.GeneralDeductions.TaxEmbargo,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.OD.GeneralDeductions.TaxEmbargo) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.SupplementalPlan.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[12] || (_cache[12] = ($event: any) => ($setup.v$.SupplementalPlan.$touch())),
              modelValue: $setup.OD.GeneralDeductions.SupplementalPlan,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.OD.GeneralDeductions.SupplementalPlan) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Education.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[14] || (_cache[14] = ($event: any) => ($setup.v$.Education.$touch())),
              modelValue: $setup.OD.GeneralDeductions.Education,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.OD.GeneralDeductions.Education) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.RefundDeduction.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[16] || (_cache[16] = ($event: any) => ($setup.v$.RefundDeduction.$touch())),
              modelValue: $setup.OD.GeneralDeductions.RefundDeduction,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.OD.GeneralDeductions.RefundDeduction) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Debt.$error }]),
              maxFractionDigits: 0,
              onBlur: _cache[18] || (_cache[18] = ($event: any) => ($setup.v$.Debt.$touch())),
              modelValue: $setup.OD.GeneralDeductions.Debt,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.OD.GeneralDeductions.Debt) = $event))
            }, null, 8, ["modelValue", "class"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_11, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.TaxEmbargo.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.TaxEmbargo.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SupplementalPlan.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.SupplementalPlan.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Education.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Education.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.RefundDeduction.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.RefundDeduction.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Debt.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Debt.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}